<template>
  <v-menu transition="slide-y-transition" left offset-y>
    <template v-slot:activator="{ on }">
      <v-btn text v-on="on">
        <v-btn v-if="activeAction" icon @click="$emit('clear-action')">
          <v-icon :size="iconSize">
            mdi-close
          </v-icon>
        </v-btn>
        <span v-text="getSelectLabel()" />
      </v-btn>
    </template>
    <v-list>
      <v-list-item
        v-for="action in actions"
        :key="action.value"
        link
        @click="$emit('activate-action', action)"
        v-text="action.text"
      >
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  props: {
    actions: {
      type: Array,
      default: () => []
    },
    activeAction: {
      type: Object,
      default: () => undefined
    },
    iconSize: {
      type: Number,
      default: 18
    },
    label: {
      type: String,
      default() {
        return this.$t("Components.DataTable.MassActionSelectActionLabel");
      }
    }
  },
  methods: {
    getSelectLabel() {
      return this.activeAction ? this.activeAction.text : this.label;
    }
  }
};
</script>
